import { AccountHolder } from "@tlc/ls2pac/components/Account";
import { TLCEvents } from "../../../../js/lib/events/events";
import { TLCRest } from "../../../../js/lib/rest/REST";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { ApplicationData } from "../ApplicationData";

class ClientManager {
  placeHoldEvent = LS2PAC_CONSTANTS.Events.onEResourcePlaceHold;
  checkoutEvent = LS2PAC_CONSTANTS.Events.onEResourceCheckout;
  updateDigitalLoanEvent = LS2PAC_CONSTANTS.Events.updateDigitalLoanEvent;
  renewEvent = LS2PAC_CONSTANTS.Events.onEResourceRenew;
  returnEvent = LS2PAC_CONSTANTS.Events.onEResourceReturn;
  checkoutEventResponse = LS2PAC_CONSTANTS.Events.onEResourceCheckoutResponse;
  
  constructor() {
    this.addEvents();
  }

  addEvents() {
    TLCEvents.on(this.placeHoldEvent, (event) => this.placeHold(event));
    TLCEvents.on(this.checkoutEvent, (event) => this.checkout(event));
    TLCEvents.on(this.updateDigitalLoanEvent, (event) =>
      this.updateDigitalLoan(event)
    );
    TLCEvents.on(this.renewEvent, (event) => this.renew(event));
    TLCEvents.on(this.returnEvent, (event) => this.returnEResource(event));
  }

  placeHold(event) {
    var myResponse = { success: false },
      postData = {
        titleId: event.resource.eResourceId,
        format: event.format, //TODO: format is not used
        service: event.resource.eResourceService,
        emailAddress: event.email, //TODO: email is not used
      };

    TLCRest.jsonCall(LS2PAC_CONSTANTS.restUrls.eResourcePlaceHold, {
      postData: postData,
      timeout: 60000,
      cancellable: true,
      cache: false,
      callback: function (response) {
        myResponse = $.extend(myResponse, response);
      },
      finallyHandler: function () {
        if (myResponse.success) {
          AccountHolder.fetchAccountSummaryAndPatron(true);
        }
        TLCEvents.trigger(
          LS2PAC_CONSTANTS.Events.onEResourcePlaceHoldResponse,
          myResponse
        );
      },
    });
  }

  checkout(event) {
    var myResponse = {
        success: false,
        downloadImmediately: event.downloadImmediately,
      },
      postData = {
        titleId: event.resource.eResourceId,
        format: event.format,
        service: event.resource.eResourceService,
      };

    TLCRest.jsonCall(LS2PAC_CONSTANTS.restUrls.eResourceCheckout, {
      postData: postData,
      timeout: 60000,
      cancellable: true,
      cache: false,
      callback: function (response) {
        myResponse = $.extend(myResponse, response);

        if (myResponse.expirationDate) {
          myResponse.expirationDate = new Date(myResponse.expirationDate);
          myResponse.expirationDateWithFormat =
            myResponse.expirationDate.format(
              ApplicationData.language.dateFormat
            );
        }
      },
      finallyHandler: () => {
        if (myResponse.success) {
          AccountHolder.fetchAccountSummaryAndPatron(true);
        }
        TLCEvents.trigger(
          this.checkoutEventResponse,
          myResponse
        );
      },
    });
  }

  updateDigitalLoan(event) {
    var response = {},
      success = false;
    TLCRest.jsonCall(LS2PAC_CONSTANTS.restUrls.eResourceRefresh, {
      callback: function (event) {
        response.lastUpdated = event.lastUpdated;
        response.thereAreChanges = event.thereAreChanges;
        response.messageToken = event.messageToken;
        success = event.success;
      },
      finallyHandler: function () {
        response.success = success;
        TLCEvents.trigger(
          LS2PAC_CONSTANTS.Events.updateDigitalLoanEventResponse,
          response
        );
      },
      timeout: 60000,
      postData: {
        patronId: ApplicationData.currentUser.patronId,
      },
      cancellable: true,
    });
  }

  renew(event) {
    var response = {},
      success = false,
      postData = {
        titleId: event.resource.eresourceId,
        service: event.resource.eresourceService,
        patronId: ApplicationData.currentUser.patronId,
      };

    TLCRest.jsonCall(LS2PAC_CONSTANTS.restUrls.eResourceRenew, {
      callback: function (event) {
        response.onHoldForAnotherUser = event.onHoldForAnotherUser;
        response.renewalsNotAllowed = event.renewalsNotAllowed;
        response.maxedOut = event.maxedOut;
        response.allCopiesOnHold = event.allCopiesOnHold;
        success = event.success;
      },
      finallyHandler: function () {
        response.success = success;
        TLCEvents.trigger(
          LS2PAC_CONSTANTS.Events.onEResourceRenewResponse,
          response
        );
      },
      timeout: 60000,
      postData: postData,
      cancellable: true,
    });
  }

  returnEResource(event) {
    var response = {},
      success = false,
      postData = {
        titleId: event.resource.eresourceId,
        service: event.resource.eresourceService,
        patronId: ApplicationData.currentUser.patronId,
      };

    TLCRest.jsonCall(LS2PAC_CONSTANTS.restUrls.eResourceReturn, {
      callback: function (event) {
        success = event.success;
        response.message = event.message;
      },
      finallyHandler: function () {
        response.success = success;
        TLCEvents.trigger(
          LS2PAC_CONSTANTS.Events.onEResourceReturnResponse,
          response
        );
      },
      timeout: 60000,
      postData: postData,
      cancellable: true,
    });
  }
}

export const EResourceCheckoutsClientManager = new ClientManager();
